<div *ngIf="statusIcon"
    class="status-icon">
    <app-scheduling-status-icon [schedulingStatus]="statusIcon">
    </app-scheduling-status-icon>
</div>
<ng-content></ng-content>